<div mat-dialog-title class="cust-modal-title">
    <h2 class="m-0" id="toClick">Job offer</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
   </div>




  <mat-dialog-content >
  <div class="help_accd" style="background: #fafafa;">
        <div class="enrolled_membership_op">
             <div class="row">
                <div class="col-sm-12">
                   <div class="test" style="padding: 0px; margin-bottom: 15px; position: relative; background: #fff; ">
                      <!-- <mat-dialog-content> -->
                         <div class="fl_orders" *ngFor="let item of jobOfferData">
                            <div class="top_section_order">
                               <div class="newclakl">
                                  <div class="hj_news">
                                     <div class="img_cont">
                                        <div class="ads_sec">
                                           <div
                                              class="hm_icon_progr">
                                              <div class="plpk">
                                                 <img [src]="item.entityInfo.default_thumb_image" onerror="this.src='../../../../../assets/images/entity_placeholder.png'" />
                                              </div>
                                           </div>
                                        </div>
                                     </div>
                                     <div class="desc_cont">
                                        <div class="order_dec">
                                           <h3
                                              style="-webkit-box-orient: vertical; display: -webkit-box;  -webkit-line-clamp: 1;  overflow: hidden; text-overflow: ellipsis;
                                              white-space: normal;
                                              margin-bottom: 10px;
                                              font-size: 18px;
                                              font-weight: bold;">  {{item.title}}
                                           </h3>
                                           <p style="color: #585858 !important; font-size: 14px !important;
                                           display: -webkit-box;
                                           -webkit-line-clamp: 1;
                                           -webkit-box-orient: vertical;
                                           overflow: hidden;
                                           text-overflow: ellipsis;">
                                           <mat-icon>location_on</mat-icon>
                                          {{item.entityInfo.address}} 
                                           </p>
                                           <p>
                                             <mat-icon>call</mat-icon>   {{item.entityInfo.country_code}} {{item.entityInfo.phone}}
                                          </p>
                                           <p style="color: #585858 !important; font-size: 14px !important;
                                           display: -webkit-box;
                                           -webkit-line-clamp: 2;
                                           -webkit-box-orient: vertical;
                                           overflow: hidden;
                                           text-overflow: ellipsis;">
                                            <mat-icon>list_alt</mat-icon>
                                            Salary: {{item.entityInfo.currency_symbol}}{{item.joiningSalary}}, Joining: {{item.joiningDate | date}}
                                           </p>
                                         
                                        </div>
                                     </div>
                                  </div>
                                  <div class="sub_heading_feet">
                                    <p> {{item.title}} added you as an employee. Accept the job offer or deny if it's not for you. Contact support for any issue.
                                    </p>
                                  </div>
                               </div>
                               <div class="acpt_bbtn">
                               <button mat-button  color="primary" class="reject_btn" (click)="setAcceptanceStatus(2,item)">Deny </button>
                               <button mat-flat-button color="accent" class="accept_btn" (click)="setAcceptanceStatus(1,item)">Accept</button>
                              </div>
                            </div>
                         </div>
  
  
                      <!-- </mat-dialog-content> -->
                   </div>
  
                </div>
  
             </div>
          </div>
  </div>
  </mat-dialog-content>
  <!-- <mat-dialog-actions align="end" style="border-top: 1px solid #ddd;">
  
  </mat-dialog-actions> -->
  